import { render, staticRenderFns } from "./osmoticChart.vue?vue&type=template&id=7552b436&"
import script from "./osmoticChart.vue?vue&type=script&lang=js&"
export * from "./osmoticChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports